import useGetInternalWidgetConfig from '@hooks/api/queries/useGetInternalWidgetConfig';
import { WidgetTypeDeviceList } from '@src/types/Widget';
import { GridRowId } from '@mui/x-data-grid-pro';
import { bmsSx } from '@src/components/_shared/sxStyles/Datatable/deviceTableList';
import WidgetDeviceList from '@src/components/_shared/WidgetDeviceList';

function RackContainer({
  bmsId,
  unitControllerId,
  unitEngineeringId,
}: {
  bmsId: GridRowId;
  unitControllerId: string;
  unitEngineeringId: string;
}) {
  const { data: widgetConfig } =
    useGetInternalWidgetConfig<WidgetTypeDeviceList>(
      'rackList',
      {
        sourceDeviceId: bmsId as string,
        unitControllerId,
        unitControllerEngineeringId: unitEngineeringId,
      },
      {
        queryKeys: [bmsId as string, unitControllerId],
        enabled: !!bmsId && !!unitControllerId && !!unitEngineeringId,
      },
    );

  return (
    <div>
      {widgetConfig && (
        <WidgetDeviceList
          id={`rack_${bmsId}_${unitControllerId}_${unitEngineeringId}`}
          widgetConfig={widgetConfig}
          sx={bmsSx.detailDataTable}
          unitControllerId={unitControllerId}
          unitControllerEngineeringId={unitEngineeringId}
        />
      )}
    </div>
  );
}

export default RackContainer;
